export enum Collections {
    HELP_CHATS = 'HelpChats',
    HELP_MESSAGES = 'HelpMessages',
    HELP_MESSAGE_ATTACHMENTS = 'HelpMessageAttachments',
    APPLICATION_VERSIONS = 'ApplicationVersions',
    EMAILS = 'Emails',
    PUSH_NOTIFICATIONS = 'PushNotifications',
    FCM_TOKENS = 'FcmTokens',
    APP_USERS = 'AppUsers',
    ORGS = 'Orgs',
    ORG_USERS = 'OrgUsers',
    ORG_USER_INVITES = 'OrgUserInvites',
    ORG_USER_EMAIL_INVITES = 'OrgUserEmailInvites',
    OFFERS = 'Offers',
    OFFER_MESSAGES = 'OfferMessages',
    OFFER_DRAFTS = 'OfferDrafts',
    SEND_OFFER_REQUESTS = 'SendOfferRequests',
    PRICE_FIELDS = 'PriceFields',
    PRICE_FIELD_TEMPLATES = 'PriceFieldTemplates',
    PRICE_FIELD_TEMPLATE_SUGGESTIONS = 'PriceFieldTemplateSuggestions',
    PRICE_FIELD_SUGGESTIONS = 'PriceFieldSuggestions',
    PRICE_FIELD_SUGGESTION_RESOLUTIONS = 'PriceFieldSuggestionResolutions',
    STRIPE_PRODUCTS = 'StripeProducts',
    STRIPE_PRODUCT_PRICES = 'prices',
    STRIPE_CUSTOMERS = 'StripeCustomers',
    STRIPE_CUSTOMER_CHECKOUT_SESSIONS = 'checkout_sessions',
    STRIPE_CUSTOMER_SUBSCRIPTIONS = 'subscriptions',
}

/**
 * Used for id generation (and leaves room for future expansion)
 */
export enum MockCollections {
    OFFER_ROOMS = 'OfferRooms',
    OFFER_ROOM_PRICE_FIELDS = 'OfferRoomPriceFields',
}